import { styled } from 'baseui'

export const Container = styled('div', {
    display: 'flex',
    justifyContent: 'space-around'
    // marginBottom: '2rem'
})

export const TabName = styled<'div', { $active?: boolean }>('div', ({ $theme, $active = false }) => ({
    textAlign: 'center',
    width: '100%',
    paddingBottom: '7px',
    // transition: 'border-bottom 0.3s ease, font-weight 0.3s ease',

    ...($active && {
        ...$theme.typography.LabelSmall,
        fontWeight: 700,
        borderBottom: `2px solid ${$theme.colors.primary}`,
        color: $theme.colors.primary
    }),
    ...(!$active && {
        ...$theme.typography.ParagraphSmall,
        borderBottom: '1px solid #ccc',
        fontWeight: 300
    }),
    cursor: 'pointer'
}))
